<template>
  <div class="page-wrap">
    <el-card class="page-card--full">
      <div class="page-card-body" ref="pageRoot">
        <div ref="queryBar" style="display:flex;gap:12px;align-items:center;flex-wrap:wrap;">
          <el-input v-model="keyword" placeholder="运输公司名称/编码/负责人" style="width:280px" clearable @keyup.enter.native="load" />
          <el-button type="primary" @click="load">查询</el-button>
          <el-button @click="loadBaseOptions">刷新下拉数据</el-button>
        </div>

        <el-table :data="list" :height="tableHeight" style="width:100%;" size="small">
          <el-table-column prop="partnerCode" label="公司编码" width="140" />
          <el-table-column prop="partnerName" label="运输公司" min-width="200" />
          <el-table-column prop="leader" label="负责人" width="120" />
          <el-table-column prop="phone" label="联系方式" width="140" />
          <el-table-column prop="areaCount" label="物流区域数" width="120" />
          <el-table-column prop="staffCount" label="物流员数" width="120" />
          <el-table-column prop="uTime" label="更新时间" width="180" />
          <el-table-column label="操作" width="120">
            <template slot-scope="s">
              <el-button type="text" @click="openConfig(s.row)">配置</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div ref="pagerBar" class="pager-bar">
          <el-pagination
            layout="total, prev, pager, next"
            :current-page.sync="pageNum"
            :page-size="pageSize"
            :total="total"
            @current-change="load"
          />
        </div>
      </div>
    </el-card>

    <el-dialog title="运输公司配置" :visible.sync="dlg" width="760px">
      <el-form :model="form" label-width="120px">
        <el-form-item label="运输公司">
          <el-select v-model="form.partnerId" style="width:100%" placeholder="请选择已开通运输公司" @change="onPartnerChange">
            <el-option v-for="p in companyOptions" :key="p.partnerId" :label="`${p.partnerName}（${p.partnerCode || '-'}）`" :value="p.partnerId" />
          </el-select>
        </el-form-item>
        <el-form-item label="物流区域">
          <el-cascader
            v-model="form.areaCodes"
            :options="areaOptions"
            :props="areaCascaderProps"
            clearable
            style="width:100%"
            collapse-tags
            collapse-tags-tooltip
            placeholder="可多选省市区"
          />
        </el-form-item>
        <el-form-item label="绑定物流员">
          <el-select v-model="form.staffUserIds" multiple filterable clearable style="width:100%" placeholder="可绑定多个物流员">
            <el-option
              v-for="u in staffOptions"
              :key="u.appUserId"
              :label="`${u.nickName || '未知'}（${u.phone || '未绑定'}）${roleTag(u.roleType)}`"
              :value="u.appUserId"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dlg=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '../../utils/request'
import tableAutoHeight from '../../mixins/tableAutoHeight'

export default {
  name: 'BizTransportCompany',
  mixins: [tableAutoHeight],
  data() {
    return {
      keyword: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      list: [],

      companyOptions: [],
      areaOptions: [],
      staffOptions: [],
      areaCascaderProps: { value: 'value', label: 'text', children: 'children', emitPath: false, multiple: true, checkStrictly: false },

      dlg: false,
      saving: false,
      form: {
        partnerId: '',
        areaCodes: [],
        staffUserIds: []
      }
    }
  },
  created() {
    this.loadBaseOptions()
    this.load()
  },
  methods: {
    roleTag(roleType) {
      if (Number(roleType) === 1) return ' [物流员]'
      if (Number(roleType) === 3) return ' [高级权限]'
      return ''
    },
    toThreeLevelTree(tree) {
      return (tree || []).map((province) => ({
        value: province.value,
        text: province.text,
        children: ((province.children || []).map((city) => ({
          value: city.value,
          text: city.text,
          children: ((city.children || []).map((area) => ({
            value: area.value,
            text: area.text,
            leaf: true
          })))
        })))
      }))
    },
    async loadBaseOptions() {
      const [companies, areaTree, staffs] = await Promise.all([
        request.get('/admin/api/biz/transport-company/options'),
        request.get('/admin/api/biz/transport-company/area/tree'),
        request.get('/admin/api/biz/transport-company/staff/options')
      ])
      this.companyOptions = companies || []
      this.areaOptions = this.toThreeLevelTree(areaTree || [])
      this.staffOptions = staffs || []
    },
    async load(page) {
      if (typeof page === 'number') this.pageNum = page
      const pageData = await request.get('/admin/api/biz/transport-company/page', {
        params: { keyword: this.keyword, pageNum: this.pageNum, pageSize: this.pageSize }
      })
      this.list = pageData.records || []
      this.total = pageData.total || 0
      this.$nextTick(() => this.updateTableHeight())
    },
    openConfig(row) {
      this.form = {
        partnerId: row && row.partnerId ? row.partnerId : '',
        areaCodes: [],
        staffUserIds: []
      }
      this.dlg = true
      if (this.form.partnerId) this.loadDetail(this.form.partnerId)
    },
    async onPartnerChange(partnerId) {
      if (!partnerId) {
        this.form.areaCodes = []
        this.form.staffUserIds = []
        return
      }
      await this.loadDetail(partnerId)
    },
    async loadDetail(partnerId) {
      const detail = await request.get('/admin/api/biz/transport-company/' + partnerId + '/detail')
      this.form.areaCodes = detail.areaCodes || []
      this.form.staffUserIds = detail.staffUserIds || []
    },
    async save() {
      if (this.saving) return
      if (!this.form.partnerId) {
        this.$message.warning('请选择运输公司')
        return
      }
      this.saving = true
      try {
        await request.put('/admin/api/biz/transport-company/' + this.form.partnerId + '/config', {
          areaCodes: this.form.areaCodes || [],
          staffUserIds: this.form.staffUserIds || []
        })
        this.$message.success('保存成功')
        this.dlg = false
        await this.load()
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

